module.exports = __webpack_public_path__ + "static/fonts/feather.a940fe8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/package/theme/fonts/feather.ttf
// module id = 9zYD
// module chunks = 5